"use strict";

var formatPriceLabelOrElse = function formatPriceLabelOrElse(price, orElse) {
  return price != null ? formatPriceLabelWithUnit(price, 'kr') : orElse;
};
var formatPriceLabel = function formatPriceLabel(price) {
  return formatPriceLabelWithUnit(price, 'kr');
};
var formatPriceLabelWithUnit = function formatPriceLabelWithUnit(price, unit) {
  var formatter = new Intl.NumberFormat('no-NO', {
    style: 'decimal',
    currency: 'NOK'
  });
  return "".concat(formatter.format(price), " ").concat(unit);
};
var formatAmount = function formatAmount(price) {
  var formatter = new Intl.NumberFormat('no-NO', {
    style: 'decimal'
  });
  return "".concat(formatter.format(price));
};
var abbreviateNumber = function abbreviateNumber(value) {
  var newValue = value;
  if (value >= 1000) {
    var suffixes = ['', 'k', 'm', 'b', 't'];
    var suffixNum = Math.floor("".concat(value).length / 3);
    var shortValue = '';
    for (var precision = 2; precision >= 1; precision--) {
      shortValue = parseFloat((suffixNum !== 0 ? value / Math.pow(1000, suffixNum) : value).toPrecision(precision));
      var dotLessShortValue = "".concat(shortValue).replace(/[^a-zA-Z 0-9]+/g, '');
      if (dotLessShortValue.length <= 2) {
        break;
      }
    }
    if (shortValue % 1 !== 0) shortValue = shortValue.toFixed(1);
    newValue = shortValue + suffixes[suffixNum];
  }
  return newValue;
};
module.exports = {
  formatPriceLabelOrElse: formatPriceLabelOrElse,
  formatPriceLabel: formatPriceLabel,
  formatPriceLabelWithUnit: formatPriceLabelWithUnit,
  formatAmount: formatAmount,
  abbreviateNumber: abbreviateNumber
};